import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ClipGroupingDecision, ClipGroupingSettings } from '../interfaces/clip-grouping.interfaces';

// Hand-written HTTP calls (not the generated api-clipping SDK) for the automatic clip grouping
// endpoints - see clip-grouping.interfaces.ts for why. Auth header is added by the app's existing
// HTTP interceptor, same as every other service here.
@Injectable({ providedIn: 'root' })
export class ClipAutoGroupingApiService {
	private readonly base = `${environment.apiClippingUrl}/v1/management`;

	constructor(private http: HttpClient) {}

	getSettings(): Observable<ClipGroupingSettings> {
		return this.http.get<ClipGroupingSettings>(`${this.base}/clip-grouping-settings`);
	}

	updateSettings(settings: Partial<ClipGroupingSettings>): Observable<ClipGroupingSettings> {
		return this.http.put<ClipGroupingSettings>(`${this.base}/clip-grouping-settings`, settings);
	}

	getRecentDecisions(limit = 200): Observable<ClipGroupingDecision[]> {
		return this.http.get<ClipGroupingDecision[]>(`${this.base}/clip-grouping-decisions`, { params: { limit } });
	}
}
